import Environment from "modules/environment"
import moment from "moment"
import Utils from "modules/utils"
import FooterBoxes from "modules/footerBoxes"
import tr from "modules/translate"
import MobileOverlayBox from "modules/mobileOverlayBox"
import "modules/jquery/bootstrap/bootstrap.min.css"
import "./style.css"
import postMessage from "modules/postMessage"
import Form from "modules/form"
import FormUser from "modules/form/user"

import { strip } from "../../modules/helpers/functions"
import { unescape } from "lodash"

import v3 from "modules/recaptcha/v3"

import dataStorage from "modules/dataStorage"
import jwt from "jsonwebtoken"

const finishQuizCallback = (score, scorePossible) => {
    score = { earned: score !== undefined ? score : null, possible: scorePossible !== undefined ? scorePossible : null }
    postMessage.send("finishedSurvey", { score: score }, function(_data) {}, Environment.field)
}

var Quiz = {
    async initialize() {
        let data = await Environment.init()
        this.responses = {}
        this.user = Environment.user || null
        this.userInfo = {}
        this.taker = {}
        this.preview = Environment.admin_preview
        this.currQuestion = -1
        this.currSection = 0
        this.currChoice = null
        this.totalQuestions = 0
        this.answeredQuestions = 0
        this.longestSection = 0
        this.extra = Environment.extra ? JSON.parse(Environment.extra) : null
        this.referrerId = Environment.entry_id || ""
        this.shareType = Environment.share_type || ""
        this.modules = {
            form: null,
        }

        $.each(data, (property, value) => {
            if (["app_id", "opt_in_show", "form_id"].indexOf(property) > -1 && value != null) value = parseInt(value)
            this[property] = value
        })

        this.totalSections = this.sections.length

        this.show_user_choices = this.show_user_choices > 0
        this.show_response_stats = this.show_response_stats > 0
        this.show_correct_answers = this.show_correct_answers > 0
        this.show_title = this.show_title > 0
        this.show_share_options = this.show_share_options > 0

        if (this.schedule_status !== "live" && this.schedule_status !== "unscheduled" && !Environment.admin_preview) {
            this.showInactivePage()
            return
        }

        this.hasForm = !!this.form_id

        this.setupStructure()
        this.setTheme()

        const firstQuestion = this.sections?.[0].questions?.[0]
        if (this.type == "poll" && firstQuestion && ((firstQuestion.media && firstQuestion.media.type) || firstQuestion.banner_image)) {
            ;("do nothing")
        } else {
            this.changeHeaderMedia("image", this.primary_image, this.primary_image_display === "cover")
        }

        this.tokenManager = v3
            .init({
                v3Key: process.env.CAMPAIGN_RECAPTCHA_V3_SITE,
                v2Key: process.env.CAMPAIGN_RECAPTCHA_V2_SITE,
                useFallback: true,
            })
            .getTokenManager()

        this.initializeUserInfo().then(() => {
            this.showUserInfo()
        })

        if (this.type === "poll") {
            this.beginQuestions()
        } else {
            this.showInitialInfo()
        }

        this.sections.forEach((section) => {
            if (!section.questions) section.questions = []
            else this.totalQuestions += section.questions.length
        })
        this.pointsPossible = this.sections.length * this.longestSection

        this.initOverlayBoxes()

        this.nameType = {
            survey: "Survey",
            graded: "Quiz",
            outcome: "Quiz",
            poll: "Poll",
        }[this.type]

        this.nameType = tr("quiz.name." + this.type, this.nameType)

        FooterBoxes.init(this, $(".quizFooter"), { size: "large" })
        this.listeners()
        Environment.triggerTrackers("oncompletion")

        this.getCurrentTaker()

        window.setTimeout(() => {
            this.setIframeHeight()
        }, 300)

        return this
    },
    initializeForm(formConfig) {
        const target = $(".wrapper .question")
        let schedule_status = this.schedule_status

        if (schedule_status == "unscheduled") {
            schedule_status = "live"
        }

        this.form.container = target.find(".formWrapper")
        this.modules.form = Form.init(this, this.form, "inline", { ...formConfig, schedule_status, inQuiz: true })
        target.find(".formContainer").addClass("centeredForm")
    },
    setTheme() {
        let normal = Quiz.theme_color || Environment.theme || "5f0c8c"
        let dark = Quiz.theme_color_dark || "999"
        let styleElement = $(/*html*/ `
            <style class="theme-style" tyle="text/css">
                .questionTitle .text {
                    background: #${normal};
                }
                .questionTitle {
                    border-color: #${dark};
                }
                .themeBtn {
                    color: #FFF;
                    background: #${normal};
                    transition: all ease-in-out 0.15s;
                    box-shadow: 0 0 0 50px rgba(0, 0, 0, 0.0) inset;
                }
                .themeBtn:hover,
                .themeBtn:focus,
                .themeBtn.active {
                    color: #FFF;
                    background: #${normal};
                    box-shadow: 0 0 0 50px rgba(0, 0, 0, 0.3) inset;
                }
                .quizHeader {
                    border-color: #${normal};
                }

                input:focus {
                    border-bottom-color: #${normal};
                }

                .inputWrapper.focus .floatingLabel {
                    color: #${normal};
                }
                .progress-bar {
                    background-color: #${normal};
                }
                .choice.chosen {
                    background: #${normal};
                    color: #fff;
                }
                .picked .score-marker {
                    background: #${normal};
                }
                .rewardsPopup .popupHeader {
                    background: #${normal};
                    border-color: #${dark};
                }
            </style>
        `)
        $("head").append(styleElement)
    },
    listeners() {
        $("body").on("focus keyup blur", "input[type=text]", function(e) {
            var input = $(this),
                wrapper = input.closest(".inputWrapper")
            if (!wrapper.length) {
                return
            }
            if (e.type == "keyup") {
                if (input.hasClass("validationError")) {
                    input.removeClass("validationError")
                    input
                        .next()
                        .find(".validationMessage")
                        .empty()
                }
                wrapper.toggleClass("dirty", input.val().length > 0)
            } else {
                wrapper.toggleClass("focus", input.is(":focus"))
            }
        })

        $("body").on("click", ".finishBtn", function() {
            $(".wrapper").html(unescape(Quiz.finish_message))
        })

        $(document).ajaxStart(function() {
            if (!Quiz.isFinished()) {
                $(".redloader").show()
            }
        })

        $(document).ajaxStop(function() {
            $(".redloader").hide()
        })

        $(".redloader.theme_font_color").remove()

        const resizeDebounce = () => {
            clearTimeout(resizeDebounce.handle)
            resizeDebounce.handle = setTimeout(() => {
                Quiz.resize()
                setTimeout(() => {
                    Quiz.setIframeHeight()
                }, 100)
            }, 250)
        }

        resizeDebounce()

        $(window).on("resize", function() {
            resizeDebounce()
        })

        setTimeout(function() {
            resizeDebounce()
            setTimeout(function() {
                resizeDebounce()
            }, 500)
        }, 500)
    },

    initializeUserInfo: function() {
        if (this.extra && this.extra.account_person_hash) {
            return $.api.accountPerson
                .findByAppIdAndHash({
                    app_id: this.app_id,
                    account_person_hash: this.extra.account_person_hash,
                })
                .then((result) => {
                    if (result.status == "success") {
                        Quiz.userInfo = Object.assign(Quiz.userInfo, result.data)
                    }
                })
        } else if (Quiz.user) {
            return $.api.quiz.getUserInfo({ user_id: Quiz.user }).then((result) => {
                if (result.status == "success") {
                    Quiz.userInfo = Object.assign(Quiz.userInfo, result.data.user)
                }
            })
        } else {
            if (Quiz.user) {
                Quiz.userInfo = Quiz.user
            }

            return $.Deferred().resolve(null)
        }
    },
    showUserInfo: function() {
        $.each(Quiz.userInfo, function(prop, value) {
            $('input[data-user-field="' + prop + '"]').val(value)
        })
    },

    initOverlayBoxes: function() {
        if ((Quiz.mobileOverlayBoxes || 0).length) {
            $(".mobileOverlayBoxesWrap.top").addClass("has-boxes")
            Quiz.mobileOverlayBoxes = Quiz.mobileOverlayBoxes.map(function(box) {
                return MobileOverlayBox.init(box, Quiz)
            })
        }
    },
    changeHeaderMedia: function(mediaType, src, backgroundOnly) {
        var target = $(".quizHeaderImage"),
            header = target.closest(".quizHeader"),
            currentMediaType = target.find("video").length ? "video" : target.find("audio").length ? "audio" : target.find("img").length ? "image" : "none"

        if (mediaType != currentMediaType || mediaType != "image") {
            target.html(
                (mediaType == "audio" ? '<div class="audio-wrapper">' + "<audio controls>" + '<source src="' + process.env.CDN + src + '"></source>' + "</audio>" + "</div>" : "") +
                    (mediaType == "video" ? "<video controls>" + '<source src="' + process.env.CDN + src + '"></source>' + "</video>" : "") +
                    (mediaType == "image" ? '<img src="' + process.env.CDN + "xl_" + src + '">' : "")
            )

            if (mediaType == "image") {
                target.find("img").bannerImage({ backgroundOnly: backgroundOnly })
            }
        }

        if (mediaType == "video") {
            // handle video
        } else if (mediaType == "audio") {
            // handle audio
        } else if (mediaType == "image") {
            if (backgroundOnly !== undefined) {
                var img = target.find("img"),
                    bi = img.data("BannerImage")
                bi.options.backgroundOnly = backgroundOnly
                bi.options.backgroundEffectClasses = backgroundOnly ? [] : ["opacity-65", "blur-10"]
            }

            img.trigger("banner-image.update", [process.env.CDN + "xl_" + src])
        }

        target.removeClass("media-audio media-video media-image").addClass("media-" + mediaType)
        header
            .toggleClass("hasImage", !!src)
            .toggleClass("hasTitle", !!Quiz.title)
            .toggleClass("noTitle", Quiz.show_title < 1 || mediaType == "video")
    },

    getAppTypeName() {
        const appTypename = this.app_type.toLowerCase()

        if (appTypename === "quiz") {
            return "quiz"
        }

        if (appTypename === "poll" && this.type === "survey") {
            return "survey"
        }

        if (appTypename === "poll" && this.type === "poll") {
            return "poll"
        }

        return appTypename
    },

    showInactivePage() {
        const appTypeName = this.getAppTypeName()
        const timezoneString = Utils.toReadableTimeZone(this.accountData.time_zone)
        const timezoneSlug = Utils.toTimeZoneSlug(this.accountData.time_zone)
        const startDateTime = moment(this.start_time).format("dddd, MMMM D [at] h:mm A z")
        let timezoneMessage = tr(timezoneSlug, timezoneString)
        let message = `This ${appTypeName}  will be available beginning ${startDateTime} ${timezoneMessage}`

        if (moment().isAfter(this.end_time)) {
            message = "Sorry, this promotion is not active"
        }

        var footer = $('<div class="quizFooter"></div>'),
            content = $(`<div><br><br><h3 style="text-align:center; font-weight:bold; font-variant:all-small-caps;">${message}</h3><br><br></div>`)

        $(".wrapper")
            .append(content)
            .append(footer)

        FooterBoxes.init(Quiz, $(".quizFooter"), { size: "large" })
    },
    setupStructure: function() {
        $(".progressWrapper").removeClass("hidden")

        var header = $(
                '<div class="quizHeader">' +
                    '<div class="quizTitle">' +
                    (Quiz.title ? '<h2 class="quizTitleHeading">' + Quiz.title + "</h2>" : "") +
                    '<div class="quizTitleContent"></div>' +
                    "</div>" +
                    '<div class="quizHeaderImage">' +
                    "</div>" +
                    "</div>"
            ),
            content = $(
                '<div class="quizContent">' +
                    '<div class="question">' +
                    '<div class="questionTitle">' +
                    '<div class="bg"></div>' +
                    '<div class="text"></div>' +
                    "<div>" +
                    "<h3></h3>" +
                    "<p></p>" +
                    "</div>" +
                    "</div>" +
                    '<div class="questionContent">' +
                    '<div class="questionBottom">' +
                    "</div>" +
                    "</div>" +
                    "</div>" +
                    "</div>"
            ),
            footer = $('<div class="quizFooter"></div>')

        $(".wrapper")
            .append(header)
            .append(content)
            .append(footer)
    },
    makeRequiredFields: function(target) {
        var fields = Quiz.required_fields ? Quiz.required_fields.split(",") : null
        const optInLists = this.getOptIns()
        var isSalem = false
        if (this.account == "602934142" || this.ancestorAccounts.includes("602934142")) {
            isSalem = true
        }
        if (fields) {
            $.each(fields, (_, field) => {
                let value
                let placeholder
                let choiceElement
                switch (field) {
                    case "first_name":
                        value = Quiz.userInfo.first_name || (Quiz.userInfo.name || "").split(" ")[0]
                        placeholder = tr("quiz.initial.first_name.placeholder", "First Name")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='first_name' placeholder='" + placeholder + "' value='" + value + "'>")
                        break
                    case "last_name":
                        value = Quiz.userInfo.last_name || (Quiz.userInfo.name || "").split(" ").slice(-1)[0]
                        placeholder = tr("quiz.initial.last_name.placeholder", "Last Name")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='last_name' placeholder='" + placeholder + "'value='" + value + "'>")
                        break
                    case "email":
                        value = Quiz.userInfo.email || ""
                        placeholder = tr("quiz.initial.email.placeholder", "Email")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='email' placeholder='" + placeholder + "'value='" + value + "'>")
                        break
                    case "gender":
                        if (isSalem) {
                            value = Quiz.userInfo.gender || ""
                            placeholder = tr("quiz.initial.gender.placeholder", "Gender")
                            choiceElement = $(strip/*html*/ `
                                <div class="inputWrapper">
                                    <label for='gender'>
                                        ${tr("quiz.initial.gender.label", "Gender")}:
                                    </label>
                                    <select name='gender' data-user-field='gender'>
                                        <option value=''>
                                            ${tr("quiz.initial.gender.choose", "Choose Your Gender...")}
                                        </option>
                                        <option  value='M' ${value == "M" && "selected"}>
                                            ${tr("quiz.initial.gender.male", "Male")}
                                        </option>
                                        <option value='F' ${value == "F" && "selected"}>
                                            ${tr("quiz.initial.gender.female", "Female")}
                                        </option>
                                    </select>
                                    <br/>
                                </div>
                            `)
                            break
                        } else {
                            placeholder = tr("quiz.initial.gender.placeholder", "Gender")
                            choiceElement = $(strip/*html*/ `
                                <div class="inputWrapper">
                                    <label for='gender'>
                                        ${tr("quiz.initial.gender.label", "Gender")}:
                                    </label>
                                    <select name='gender' data-user-field='gender'>
                                        <option value=''>
                                            ${tr("quiz.initial.gender.choose", "Choose Your Gender...")}
                                        </option>
                                        <option  value='M' ${value == "M" && "selected"}>
                                            ${tr("quiz.initial.gender.male", "Male")}
                                        </option>
                                        <option value='F' ${value == "F" && "selected"}>
                                            ${tr("quiz.initial.gender.female", "Female")}
                                        </option>
                                        <option value='O' ${value == "O" && "selected"}>
                                            ${tr("quiz.initial.gender.other", "Other")}
                                        </option>
                                    </select>
                                    <br/>
                                </div>
                            `)
                        }
                        break
                    case "phone":
                        value = Quiz.userInfo.phone || ""
                        placeholder = tr("quiz.initial.phone.placeholder", "Phone Number")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='phone' placeholder='" + placeholder + "'value='" + value + "'>")
                        break

                    case "address":
                        value = Quiz.userInfo.address || ""
                        placeholder = tr("quiz.initial.address.placeholder", "Street Address")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='address' placeholder='" + placeholder + "' value='" + value + "'>")
                        break
                    case "address_2":
                        value = Quiz.userInfo.address_2 || ""
                        placeholder = tr("quiz.initial.address_2.placeholder", "Street Address #2")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='address_2' placeholder='" + placeholder + "' value='" + value + "'>")
                        break
                    case "city":
                        value = Quiz.userInfo.city || ""
                        placeholder = tr("quiz.initial.city.placeholder", "City")
                        choiceElement = $("<input type='text' name='" + field + "' data-user-field='city' placeholder='" + placeholder + "' value='" + value + "'>")
                        break

                    case "state":
                        value = Quiz.userInfo.state || ""
                        var states = [
                            { name: "Alabama", abbreviation: "AL" },
                            { name: "Alaska", abbreviation: "AK" },
                            { name: "AmericanSamoa", abbreviation: "AS" },
                            { name: "Arizona", abbreviation: "AZ" },
                            { name: "Arkansas", abbreviation: "AR" },
                            { name: "California", abbreviation: "CA" },
                            { name: "Colorado", abbreviation: "CO" },
                            { name: "Connecticut", abbreviation: "CT" },
                            { name: "Delaware", abbreviation: "DE" },
                            { name: "DistrictOfColumbia", abbreviation: "DC" },
                            { name: "FederatedStatesOfMicronesia", abbreviation: "FM" },
                            { name: "Florida", abbreviation: "FL" },
                            { name: "Georgia", abbreviation: "GA" },
                            { name: "Guam", abbreviation: "GU" },
                            { name: "Hawaii", abbreviation: "HI" },
                            { name: "Idaho", abbreviation: "ID" },
                            { name: "Illinois", abbreviation: "IL" },
                            { name: "Indiana", abbreviation: "IN" },
                            { name: "Iowa", abbreviation: "IA" },
                            { name: "Kansas", abbreviation: "KS" },
                            { name: "Kentucky", abbreviation: "KY" },
                            { name: "Louisiana", abbreviation: "LA" },
                            { name: "Maine", abbreviation: "ME" },
                            { name: "MarshallIslands", abbreviation: "MH" },
                            { name: "Maryland", abbreviation: "MD" },
                            { name: "Massachusetts", abbreviation: "MA" },
                            { name: "Michigan", abbreviation: "MI" },
                            { name: "Minnesota", abbreviation: "MN" },
                            { name: "Mississippi", abbreviation: "MS" },
                            { name: "Missouri", abbreviation: "MO" },
                            { name: "Montana", abbreviation: "MT" },
                            { name: "Nebraska", abbreviation: "NE" },
                            { name: "Nevada", abbreviation: "NV" },
                            { name: "NewHampshire", abbreviation: "NH" },
                            { name: "NewJersey", abbreviation: "NJ" },
                            { name: "NewMexico", abbreviation: "NM" },
                            { name: "NewYork", abbreviation: "NY" },
                            { name: "NorthCarolina", abbreviation: "NC" },
                            { name: "NorthDakota", abbreviation: "ND" },
                            { name: "NorthernMarianaIslands", abbreviation: "MP" },
                            { name: "Ohio", abbreviation: "OH" },
                            { name: "Oklahoma", abbreviation: "OK" },
                            { name: "Oregon", abbreviation: "OR" },
                            { name: "Palau", abbreviation: "PW" },
                            { name: "Pennsylvania", abbreviation: "PA" },
                            { name: "PuertoRico", abbreviation: "PR" },
                            { name: "RhodeIsland", abbreviation: "RI" },
                            { name: "SouthCarolina", abbreviation: "SC" },
                            { name: "SouthDakota", abbreviation: "SD" },
                            { name: "Tennessee", abbreviation: "TN" },
                            { name: "Texas", abbreviation: "TX" },
                            { name: "Utah", abbreviation: "UT" },
                            { name: "Vermont", abbreviation: "VT" },
                            { name: "VirginIslands", abbreviation: "VI" },
                            { name: "Virginia", abbreviation: "VA" },
                            { name: "Washington", abbreviation: "WA" },
                            { name: "WestVirginia", abbreviation: "WV" },
                            { name: "Wisconsin", abbreviation: "WI" },
                            { name: "Wyoming", abbreviation: "WY" },
                        ]
                        choiceElement = $(
                            "<label>" +
                                tr("quiz.initial.address.label", "State") +
                                ": </label>" +
                                "<select data-user-field='state' name='state'>" +
                                "<option value=''>" +
                                tr("quiz.initial.address.choose", "Choose Your State...") +
                                "</option>" +
                                (function() {
                                    var str = ""
                                    $.each(states, (_, v) => {
                                        str += "<option value='" + v.abbreviation + "' " + (value == v.abbreviation ? "selected" : "") + ">" + v.name + "</option>"
                                    })

                                    return str
                                })() +
                                "</select></div>"
                        )
                        break

                    case "zip":
                        value = Quiz.userInfo.zip || ""
                        placeholder = tr("quiz.initial.zip.placeholder", "Zip")
                        choiceElement = $("<input type='text' name='zip' data-user-field='zip' placeholder='" + placeholder + "' value='" + value + "'>")
                        break
                    case "birthday":
                        value = Quiz.userInfo.birthday || ""
                        placeholder = tr("quiz.initial.birthday.placeholder", "Birthday")
                        choiceElement = $("<input type='text' class='datepicker' data-user-field='birthday' name='" + field + "' placeholder='" + placeholder + "'/>")
                        choiceElement.datepicker({ viewMode: "years" })
                        break
                }
                target.append(choiceElement)
            })

            target.find('input[type="text"]').each(function() {
                var label = $(this).attr("placeholder")
                var labelSpan = $("<div class='floatingLabel'>" + label + "<span class='validationMessage'></span></div>")
                labelSpan = $(labelSpan).insertAfter($(this))
                $(this)
                    .add(labelSpan)
                    .wrapAll('<div class="inputWrapper"></div>')
            })

            $.placeholder.shim()
        }

        if (optInLists) {
            const list = $("<div class='opt-ins'></div>").appendTo(target)
            optInLists.forEach((o, i) => {
                list.append(strip/*html*/ `
                    <div class="opt-in-preview" data-index="${i}">
                        <div class="cols">
                            <div class="col col-label">
                                <div class="content-wrap">
                                    <div class="error-text">
                                        Please subscribe to list.
                                    </div>
                                    <label>
                                        <input type="checkbox"> ${o.label || tr("quiz.optin.subscribe", "Subscribe to our newsletter")}
                                    </label>
                                </div>
                            </div>
                            <div class="col col-required">
                                ${!!o.required &&
                                    strip/*html*/ `
                                    <i class="requiredIcon fa fa-exclamation"></i>
                                `}
                            </div>
                        </div>
                    </div>
                `)
            })
        }
    },
    validateRequiredFields: function(target) {
        target.find(".validationError").removeClass("validationError")

        var fields = Quiz.required_fields ? Quiz.required_fields.split(",") : [],
            errors = []

        fields.forEach(function(name) {
            var input = target.find('[name="' + name + '"]')
            var val = input.val()?.trim?.()
            switch (name) {
                case "first_name":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.first_name.required", "First Name Is Required. ") })
                    if (val.length < 2) errors.push({ name: name, message: tr("quiz.initial.first_name.invalid", "Must Be More Than 2 Letters. ") })
                    break
                case "last_name":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.last_name.required", "Last Name Is Required. ") })
                    if (val.length < 2) errors.push({ name: name, message: tr("quiz.initial.last_name.invalid", "Must Be More Than 2 Letters. ") })
                    break
                case "email":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.email.required", "Email Is Required. ") })
                    if (val.indexOf("@") < 0) errors.push({ name: name, message: tr("quiz.initial.email.invalid", "Must Be Valid Email. ") })
                    break
                case "phone":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.phone.required", "Phone Number Is Required. ") })
                    if (val.length < 10)
                        errors.push({
                            name: name,
                            message: tr("quiz.initial.phone.invalid", "Must Include Area Code. (numbers only, no puncuation) "),
                        })
                    break
                case "address":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.address.required", "Street Address Is Required ") })
                    if (val.length < 4) errors.push({ name: name, message: tr("quiz.initial.address.invalid", "Must Be Valid Address. ") })
                    break
                case "city":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.city.required", "City Is Required. ") })
                    if (val.length < 2) errors.push({ name: name, message: tr("quiz.initial.city.invalid", "Must Be Valid City. ") })
                    break
                case "state":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.state.required", "State Is Required ") })
                    break
                case "zip":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.zip.required", "Zip Code Is Required. ") })
                    if (val.length < 4) errors.push({ name: name, message: tr("quiz.initial.zip.invalid", "Must Be Valid Zip Code. ") })
                    break
                case "birthday":
                    if (!val) errors.push({ name: name, message: tr("quiz.initial.birthday.required", "Birthday Is Required ") })
                    if (val.length < 8) errors.push({ name: name, message: tr("quiz.initial.birthday.invalid", "Must be Valid Date ") })
                    break
            }
        })

        if (errors.length) {
            errors.forEach(function(error) {
                var name = error.name,
                    msg = error.message,
                    thisInput = target.find('[name="' + name + '"]')

                thisInput
                    .addClass("validationError")
                    .next()
                    .find(".validationMessage")
                    .text(" - " + msg)

                if (!thisInput.prev().is(":visible")) {
                    let labelSpan = thisInput.prev()
                    labelSpan.css({ top: thisInput.position().top + 10, left: thisInput.position().left + 13 })
                    labelSpan.show()
                    labelSpan.animate({ top: "-=7px" }, 300)
                }
            })
        }

        return errors
    },
    getRequiredFieldsInfo: function(target) {
        var fields = Quiz.required_fields ? Quiz.required_fields.split(",") : [],
            info = {}

        fields.forEach(function(name) {
            info[name] = target.find('[name="' + name + '"]').val()
        })

        const optIns = this.getOptIns()
        const lists = []
        if (optIns) {
            optIns.forEach((o, i) => {
                const elem = target.find('.opt-in-preview[data-index="' + i + '"]')
                if (elem.find("input[type=checkbox]").is(":checked")) {
                    lists.push(...o.lists)
                }
            })

            info.lists = lists
        }
        return info
    },
    showInitialInfo: function() {
        var fields = this.required_fields ? this.required_fields.split(",") : null,
            target = $(".wrapper .question")

        this.changeHeaderMedia("image", this.primary_image ? this.primary_image : "", this.primary_image_display == "cover")

        target.find(".questionTitle h3").text(fields ? tr("quiz.initial.with_fields", "Please provide the following to begin") : tr("quiz.initial.without_fields", "Ready to begin?"))
        target
            .find(".questionTitle p")
            .toggleClass("hidden", !this.description)
            .html(this.nl2br(this.description || ""))
        if (this.offline_contest > 0) {
            target.find(".questionTitle h3").text(tr("quiz.initial.without_fields", "Ready to begin?"))
        }
        if (this.preview) {
            $(".questionBottom").append(
                '<div class="button skipBtn" style="color: #333; background-color: #eee;">' + '<i class="fa fa-chevron-right"></i> ' + tr("quiz.initial.button.skip", "Skip") + " " + "</div>"
            )
            $(".skipBtn").on("click", () => {
                $(".quizTitleContent").empty()
                $(".quizTitleContent").html(this.sections[0].section_header)
                this.saveInitialInfo(true)
            })
        }

        this.setIframeHeight()

        if (this.hasForm) {
            target.find(".questionContent").prepend('<div class="formWrapper"></div>')
            if (this.offline_contest > 0) {
                target.find(".questionBottom").append('<div class="button nextBtn themeBtn">' + tr("quiz.initial.button.begin", "Begin") + '<span class="fa fa-arrow-right"></span>' + "</div>")
                target.find(".nextBtn").on("click", () => {
                    this.createTaker().then((result) => {
                        if (result.status == "success") {
                            $(".questionContent").empty()
                            $(".quizTitleContent")
                                .empty()
                                .html(this.sections[0].section_header)
                            $(".error").remove()
                            this.beginQuestions()
                        } else {
                            if (result.statusCode == 401) {
                                this.showError(result.message)
                            } else {
                                this.showError(tr("quiz.submit.error_already", `You have already taken this [quiz_type] as many times as is allowed.`, { quiz_type: Quiz.nameType }))
                            }
                        }
                    })
                })
            } else {
                this.initializeForm({
                    events: {
                        onCompleteEntry: (data, form) => {
                            const initialInfo = form ? form.user : null
                            this.createTaker(initialInfo).then((result) => {
                                if (result.status == "success") {
                                    Object.assign(this.userInfo, initialInfo)
                                    $(".quizTitleContent").empty()
                                    $(".questionContent").empty()
                                    $(".quizTitleContent").html(this.sections[0].section_header)
                                    $(".error").remove()
                                    this.beginQuestions()
                                } else {
                                    if (result.statusCode == 401) {
                                        this.showError(result.message)
                                    } else {
                                        this.showError(tr("quiz.submit.error_already", `You have already taken this [quiz_type] as many times as is allowed.`, { quiz_type: Quiz.nameType }))
                                    }
                                }

                                if (this.userInfo && this.userInfo.person_id) {
                                    $.api.accountPerson.updateFromAppIdAndHash({
                                        app_id: this.app_id,
                                        email_hash: this.userInfo.email_hash,
                                        data: { ...this.userInfo.data, surveyStatus: "started", takerId: result.data.model.taker_id },
                                    })
                                }
                            })
                        },
                    },
                })
            }
        } else {
            //show old school questions
            target.find(".questionContent").prepend(fields ? '<div class="choiceArea padded initialInfo"></div>' : "")
            target
                .find(".questionBottom")
                .append(
                    '<div class="button nextBtn themeBtn">' +
                        (fields ? tr("quiz.initial.button.next", "Next") : tr("quiz.initial.button.begin", "Begin")) +
                        '<span class="fa fa-arrow-right"></span>' +
                        "</div>"
                )

            if (fields) {
                this.makeRequiredFields($(".wrapper .choiceArea").empty())
            }

            target.find(".nextBtn").on("click", () => {
                this.preview = false
                this.checkInitialInfo()
            })
        }
    },
    completeEntry(_form) {
        return true
    },
    checkInitialInfo: function() {
        var errors = Quiz.validateRequiredFields($(".initialInfo"))
        if (errors.length) {
            return false
        }

        if (this.getOptIns()) {
            errors = Quiz.validateOptIns()
            if (errors.length) {
                return false
            }
        }

        Quiz.saveInitialInfo()
    },
    getOptIns() {
        const optInLists =
            Quiz.opt_in_show && Quiz.opt_in_lists && Quiz.opt_in_lists.length
                ? Quiz.opt_in_lists.filter((o) => {
                      return o.lists.length
                  })
                : false

        return optInLists && optInLists.length ? optInLists : false
    },
    validateOptIns() {
        var wrapper = $(".opt-ins")
        var errors = []

        wrapper.find(".has-error").removeClass("has-error")

        this.getOptIns().forEach((o, i) => {
            var elem = wrapper.find('[data-index="' + i + '"]')
            if (o.required > 0 && !elem.find("input").is(":checked")) {
                errors.push({
                    index: i,
                })
                elem.addClass("has-error")
            }
        })

        return errors
    },
    saveInitialInfo: function(preview) {
        var initialInfo = Quiz.getRequiredFieldsInfo($(".initialInfo"))
        if (preview) {
            Quiz.taker_id = 0
            Quiz.beginQuestions()
        } else {
            initialInfo["taker_id"] = null
            Quiz.createTaker(initialInfo).then((result) => {
                if (result.status == "success") {
                    Object.assign(Quiz.userInfo, initialInfo)
                    $(".quizTitleContent").empty()
                    $(".quizTitleContent").html(Quiz.sections[0].section_header)
                    $(".error").remove()
                    Quiz.beginQuestions()
                } else {
                    if (result.statusCode == 401) {
                        Quiz.showError(result.message)
                    } else {
                        Quiz.showError(tr("quiz.submit.error_already", `You have already taken this [quiz_type] as many times as is allowed.`, { quiz_type: Quiz.nameType }))
                    }
                }

                if (Quiz.userInfo && Quiz.userInfo.person_id) {
                    $.api.accountPerson.updateFromAppIdAndHash({
                        app_id: Quiz.app_id,
                        email_hash: Quiz.userInfo.email_hash,
                        data: Object.assign(Quiz.userInfo.data, { surveyStatus: "started", takerId: result.data.model.taker_id }),
                    })
                }
            })
        }
    },
    beginQuestions: function() {
        postMessage.events.userBeginSurvey(Quiz.taker_id)
        Quiz.nextQuestion()
    },
    isAnonymous() {
        return Quiz.required_fields.split(",").indexOf("email") == -1
    },
    getCurrentTaker() {
        const current_taker = jwt.decode(dataStorage.getItem("current_taker"))
        if (current_taker) {
            this.createTaker({ taker_id: current_taker.taker_id }).then((result) => {
                if (result.status == "success") {
                    Object.assign(Quiz.userInfo, Quiz.taker)
                    $(".quizTitleContent").empty()
                    $(".quizTitleContent").html(Quiz.sections[0].section_header)
                    Quiz.beginQuestions()
                }
            })
        }
    },
    createTaker: function(info) {
        info = $.extend({ app_id: Quiz.app_id }, info)

        let getTokenPromise = Quiz.tokenManager.getToken("quiz")

        return getTokenPromise.then((token) => {
            this.tokenManager.tokenUsed()
            if (!info.taker_id) info["taker_id"] = null
            return $.api.quizTaker
                .create({ ...info, recaptchaToken: token })
                .then((result) => {
                    if (result.status == "success") {
                        Quiz.taker_id = result.data.model.taker_id
                        Quiz.taker = result.data.model
                        this.tokenManager.tokenAccepted()

                        const current_taker = jwt.decode(dataStorage.getItem("current_taker"))
                        if (!current_taker) {
                            const taker = jwt.sign(
                                {
                                    taker_id: result.data.model.taker_id,
                                },
                                "currentTaker",
                                { expiresIn: "5h" }
                            )
                            window.localStorage.setItem("current_taker", taker)
                        }
                        if (result.data.responses && result.data.responses.length > 0) {
                            this.goToQuestion(result.data.responses)
                        }
                    } else {
                        this.tokenManager.tokenRejected()
                    }
                    return result
                })
                .catch(() => {
                    this.tokenManager.tokenRejected()
                })
        })
    },
    goToQuestion(responses) {
        responses.forEach((response) => {
            this.responses["question_" + response.question_id] = { response: response.answer, question_id: response.question_id, choice_id: response.choice_id }
        })

        const lastQuestAnswered = responses[responses.length - 1]

        let count = 0
        for (let i = 0; i < this.sections.length; i++) {
            const section = this.sections[i]
            for (let j = 0; j < section.questions.length; j++) {
                count++
                const question = section.questions[j]
                if (question.question_id == lastQuestAnswered.question_id) {
                    this.currSection = i
                    this.currQuestion = j
                    this.answeredQuestions = count
                }
            }
        }
    },
    updateTaker: function(info) {
        return this.tokenManager
            .getToken("poll")
            .then((recaptchaToken) => {
                this.tokenManager.tokenUsed()

                return $.api.quizTaker.update(this.taker_id, { ...info, app_id: this.app_id, recaptchaToken })
            })
            .then((result) => {
                if (result.status == "success") {
                    this.userInfo = info
                    this.taker = result.data.model
                    this.tokenManager.tokenAccepted()
                    dataStorage.removeItem("current_taker")
                } else {
                    if (result.statusCode == 401) {
                        this.tokenManager.tokenRejected()
                    } else {
                        this.deleteTaker()
                    }
                }

                return result
            })
    },
    deleteTaker: function() {
        return $.api.quizTaker.delete(Quiz.taker_id)
    },
    checkSectionStatus: function() {
        var isFinished = this.isFinished()

        if (isFinished) {
            return isFinished
        }
        if (this.currQuestion >= this.sections[this.currSection].questions.length) {
            //go to next section if we are out of questions on the current section
            if (this.sections[this.currSection].section_reward) {
                this.showReward(this.sections[this.currSection].section_reward, this.sections[this.currSection].section_name)
            }
            this.currSection++
            this.currQuestion = 0

            while (!this.checkConditionals(null, Quiz.sections[this.currSection], null)) {
                this.currSection++
                if ((isFinished = this.isFinished())) {
                    return isFinished
                }
            }

            if (!(isFinished = this.isFinished())) {
                $(".quizTitleContent").html(this.sections[this.currSection].section_header)
            }
        }
        return isFinished
    },
    nextQuestion: function() {
        $.placeholder.shim()

        this.currQuestion++
        this.answeredQuestions++

        var isFinished = Quiz.checkSectionStatus()

        if (isFinished) {
            this.showFinished()
            return
        }

        var question = this.sections[this.currSection].questions[this.currQuestion]
        if (this.validQuestion(question)) {
            Quiz.showProgress()
            this.renderQuestion(question)
        } else {
            if (this.currQuestion < 500) {
                //prevent recursion loops
                this.nextQuestion()
            }
        }

        Quiz.setIframeHeight()
    },

    validQuestion: function(question) {
        if (!question) return false
        if (["select_one", "select_multiple", "select_rank"].includes(question.type) && !question.choices.length) {
            return false
        }
        return this.checkConditionals(question, null, null)
    },

    checkConditionals: function(question, section, outcome) {
        var meetsConditionals = true

        if (section && section.conditionals) {
            section.conditionals.forEach((conditional) => {
                if (meetsConditionals) {
                    meetsConditionals = Quiz.checkConditional(conditional)
                }
            })
        }

        if (question && question.conditionals) {
            question.conditionals.forEach((conditional) => {
                if (meetsConditionals) {
                    meetsConditionals = Quiz.checkConditional(conditional)
                }
            })
        }

        if (outcome && outcome.conditionals) {
            outcome.conditionals.forEach((conditional) => {
                if (meetsConditionals) meetsConditionals = Quiz.checkConditional(conditional)
            })
        }

        return meetsConditionals
    },
    checkConditional: function(conditional) {
        var question = Quiz.getQuestion(conditional.question_check_id)
        if (!question) return true

        var response = Quiz.responses["question_" + question.question_id]
        if (!response) return false

        var type = question.type
        var conditionalValues = conditional.value ? conditional.value.split("|") : []

        if (["select_one", "select_multiple", "select_rank"].includes(question.type)) {
            conditionalValues = conditional.choice_check_id
                ? conditional.choice_check_id.split("|").map(function(n) {
                      return parseInt(n)
                  })
                : []
        }

        var match = conditionalValues.some(function(value) {
            var a = ["select_one", "select_multiple", "select_rank"].includes(question.type) ? response.choice_id : response.response
            var b = value

            return {
                select_one: () => Quiz.stringCompare(a, b, conditional.operator),
                select_multiple: () => Quiz.arrayCompare(a, b, conditional.operator),
                select_rank: () => Quiz.arrayCompareRank(a, b, conditional.operator),
                DatePicker: () => Quiz.dateCompare(a, b, conditional.operator),
                Rater: () => Quiz.numberCompare(a, b, conditional.operator),
                Number: () => Quiz.numberCompare(a, b, conditional.operator),
                Paragraph: () => Quiz.stringCompare(a, b, conditional.operator),
            }[type]()
        })

        return match
    },
    stringCompare: function(a, b, operator) {
        return {
            "=": a == b,
            "!=": a != b,
            "<": a < b,
            ">": a > b,
            "≤": a <= b,
            "≥": a >= b,
            HAS: a.indexOf?.(b) > -1,
            "!HAS": a.indexOf?.(b) === -1,
        }[operator]
    },
    dateCompare: function(a, b, operator) {
        a = moment(a)
        b = moment(b)
        return {
            "=": a == b,
            "!=": a != b,
            "<": a < b,
            ">": a > b,
            "≤": a >= b,
            "≥": a <= b,
        }[operator]
    },

    numberCompare: function(a, b, operator) {
        a = parseFloat(a)
        b = parseFloat(b)
        return {
            "=": a == b,
            "!=": a != b,
            "<": a < b,
            ">": a > b,
            "≤": a >= b,
            "≥": a <= b,
        }[operator]
    },

    arrayCompareRank: function(a, b, operator) {
        return a.indexOf(b) > -1 && a.indexOf(b) + 1 == parseInt(operator)
    },
    arrayCompare: function(a, b, operator) {
        var match = false
        switch (operator) {
            case "=":
                match = a.includes(b)
                break
            case "!=":
                match = !a.includes(b)
                break
            default:
                match = false
        }
        return match
    },

    isFinished: function() {
        if (this.currSection >= this.sections.length) {
            return true
        } else if (this.currSection == this.sections.length && this.currQuestion >= this.sections[this.currSection].questions.length) {
            return true
        } else {
            return false
        }
    },

    shuffle: function(choices) {
        for (let i = choices.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[choices[i], choices[j]] = [choices[j], choices[i]]
        }
        return choices
    },

    renderQuestion: function(question) {
        var header = $(".quizHeader")

        header.toggleClass("noTitle", !Quiz.show_title || question.type == "Sponsor")

        if (question.media && question.media.type) {
            Quiz.changeHeaderMedia(question.media.type, question.media.file)
        } else {
            Quiz.changeHeaderMedia("image", question.banner_image || Quiz.primary_image, (question.banner_image_display || Quiz.primary_image_display) == "cover")
        }

        $(".questionTitle h3").fadeOut(100, function() {
            $(this)
                .html(question.title)
                .fadeIn()
        })

        $(".questionTitle p")
            .html(Quiz.nl2br(question.description || ""))
            .toggleClass("hidden", !question.description)

        var element = $(".questionContent").empty()
        var contentInner = $(
            "<div>" +
                '<div class="choiceArea padded">' +
                (question.type == "select_multiple" ? '<p style="padding-left: 30px; margin: 0 0 5px;text-align: left;">Select all that apply:</p>' : "") +
                "</div>" +
                "<div class='incorrectAnswerAlert'><span class='incorrectAnswerAlertText'>" +
                tr("quiz.question.incorrect.answer", "Sorry, That answer is incorrect. Please try again.") +
                "</span></div>" +
                '<div class="questionBottom">' +
                '<div class="button nextBtn themeBtn">' +
                tr("quiz.question.button.next", "Next") +
                '<span class="fa fa-arrow-right"></span>' +
                "</div>" +
                "</div>" +
                "</div>"
        ).hide()
        contentInner.appendTo(element).fadeIn()

        element.find(".choiceArea").removeAttr("data-format")

        let choiceElement
        switch (question.type) {
            case "select_one":
                var choices = question.randomize_choices == 1 ? this.shuffle(question.choices) : question.choices
                $.each(choices, (_, choice) => {
                    const choiceTextClass = choice.image ? "choiceText" : "choiceText-vertical-center"
                    choiceElement = $(
                        '<div class="choice" data-choice-id="' +
                            choice.choice_id +
                            '">' +
                            (question.question_format == "grid"
                                ? '<div class="choiceWrap" ' +
                                  (choice.image ? 'style="background-image: url(' + process.env.CDN + "medium_" + choice.image + ')"' : "") +
                                  ">" +
                                  (choice.display.trim().length ? '<div class="' + choiceTextClass + '">' + choice.display + "</div>" : "") +
                                  "</div>"
                                : choice.display) +
                            "</div>"
                    )

                    choiceElement.toggleClass("has-image", question.question_format == "grid" && !!choice.image)

                    element
                        .find(".choiceArea")
                        .removeClass("padded")
                        .attr("data-format", question.question_format)
                        .append(choiceElement)
                    element.find(".questionBottom").remove()
                })

                element.find(".choice").on("click", function() {
                    $(this).addClass("chosen")
                    var choice_id = parseInt($(this).attr("data-choice-id")),
                        choice = question.choices.find(({ choice_id: c }) => choice_id == c),
                        value = choice.value

                    Quiz.makeChoice(question, value, choice_id)
                })

                break
            case "select_rank":
                var list = $('<div class="rank-list"></div>')

                var choices = question.randomize_choices == 1 ? this.shuffle(question.choices) : question.choices
                $.each(choices, (_, choice) => {
                    const contentTextClass = choice.image ? "choiceText-vertical-center" : "choiceText"

                    choiceElement = $(
                        '<div class="choice" data-choice-id="' +
                            choice.choice_id +
                            '">' +
                            (question.question_format == "grid"
                                ? '<div class="choiceWrap" ' +
                                  (choice.image ? 'style="background-image: url(' + process.env.CDN + "medium_" + choice.image + ')"' : "") +
                                  ">" +
                                  '<span class="handle"><i class="fa fa-arrows"></i></span>' +
                                  (choice.display.trim().length ? '<div class="' + contentTextClass + '">' + choice.display + "</div>" : "") +
                                  "</div>"
                                : '<div class="choiceWrap">' +
                                  '<span class="handle"><i class="fa fa-arrows"></i></span>' +
                                  '<span class="' +
                                  contentTextClass +
                                  '">' +
                                  choice.display +
                                  "</span>" +
                                  "</div>") +
                            "</div>"
                    )

                    choiceElement.toggleClass("has-image", question.question_format == "grid" && !!choice.image)

                    list.append(choiceElement)
                })

                element
                    .find(".choiceArea")
                    .removeClass("padded")
                    .addClass(question.type)
                    .attr("data-format", question.question_format)
                    .append(
                        '<p class="help-text" style="padding-left: 30px;">' +
                            (question.question_format == "grid" ? "Rank your answers from highest/left to lowest/right" : "Rank your answers from highest to lowest") +
                            "</p>"
                    )
                    .append(list)

                var syncChoices = function() {
                    question.currChoices = []

                    element.find(".rank-list .choice").each(function() {
                        var choice_id = parseInt($(this).attr("data-choice-id"))
                        var choice = question.choices.find(({ choice_id: c }) => choice_id == c)
                        var choiceObj = { choice_id: choice_id, value: choice.value }

                        question.currChoices.push(choiceObj)
                    })
                }

                syncChoices()

                element.find(".rank-list").sortable({
                    handle: ".handle",
                    delay: $(window).width() > 991 ? 25 : 500,
                    update() {
                        syncChoices()
                        element.find(".nextBtn").removeClass("disabled")
                    },
                })
                element.find(".rank-list").disableSelection()

                element.find(".nextBtn").addClass("disabled")
                setTimeout(function() {
                    element.find(".nextBtn").removeClass("disabled")
                }, 2000)

                element.find(".nextBtn").on("click", function() {
                    if ($(this).hasClass("disabled")) {
                        return false
                    }

                    if (question.currChoices && question.currChoices.length) {
                        Quiz.makeChoice(
                            question,
                            question.currChoices.map(function(c) {
                                return c.value
                            }),
                            question.currChoices.map(function(c) {
                                return c.choice_id
                            })
                        )
                    }
                })
                break
            case "select_multiple":
                var choices = question.randomize_choices == 1 ? this.shuffle(question.choices) : question.choices
                $.each(choices, (_, choice) => {
                    const choiceTextClass = choice.image ? "choiceText" : "choiceText-vertical-center"
                    choiceElement = $(
                        '<div class="choice" data-choice-id="' +
                            choice.choice_id +
                            '">' +
                            (question.question_format == "grid"
                                ? '<div class="choiceWrap" ' +
                                  (choice.image ? 'style="background-image: url(' + process.env.CDN + "medium_" + choice.image + ')"' : "") +
                                  ">" +
                                  (choice.display.trim().length ? '<div class="' + choiceTextClass + '">' + choice.display + "</div>" : "") +
                                  "</div>"
                                : choice.display) +
                            "</div>"
                    )

                    choiceElement.toggleClass("has-image", question.question_format == "grid" && !!choice.image)

                    element
                        .find(".choiceArea")
                        .removeClass("padded")
                        .attr("data-format", question.question_format)
                        .append(choiceElement)
                })

                question.currChoices = []

                element.find(".choice").on("click", function() {
                    var choice_id = parseInt($(this).attr("data-choice-id")),
                        choice = question.choices.find(({ choice_id: c }) => choice_id == c),
                        value = choice.value

                    var choiceObj = { choice_id: choice_id, value: value }

                    if ($(this).hasClass("chosen")) {
                        $(this).removeClass("chosen")
                        var i = question.currChoices.indexOf(choiceObj)
                        question.currChoices.splice(i, 1)
                    } else {
                        $(this).addClass("chosen")
                        question.currChoices.push(choiceObj)
                    }
                })

                element.find(".nextBtn").on("click", function() {
                    if (question.currChoices && question.currChoices.length) {
                        Quiz.makeChoice(
                            question,
                            question.currChoices.map(function(c) {
                                return c.value
                            }),
                            question.currChoices.map(function(c) {
                                return c.choice_id
                            })
                        )
                    }
                })

                break
            case "DatePicker":
                element.find(".choiceArea").append('<div class="datepickerChoice"><p>' + tr("quiz.datepicker.choose", "Choose A Date") + '</p><input class="datepicker"/></div>')
                element.find(".datepicker").datepicker({ viewMode: "years" })
                element.find(".nextBtn").on("click", function() {
                    var date = element.find("input").val()
                    if (date) {
                        Quiz.makeChoice(question, date)
                    }
                })

                break
            case "Rater":
                element.find(".choiceArea").append('<div class="raterChoice"><p>' + tr("quiz.rater.choose", "Choose A Rating") + '</p><div class="rater"></div>')
                element.find(".rater").raty({
                    number: 10,
                    click(value) {
                        Quiz.makeChoice(question, value)
                    },
                })
                break
            case "Number":
                choiceElement = $('<input type="number" placeholder="' + tr("quiz.number.choose", "Enter A Number") + '"/>')
                element.find(".choiceArea").append(choiceElement)
                element.find(".nextBtn").on("click", function() {
                    var num = element.find('input[type="number"]').val()
                    if (num) {
                        Quiz.makeChoice(question, num)
                    }
                })
                break
            case "Paragraph":
                choiceElement = $('<textarea placeholder="' + tr("quiz.paragraph.text", "type your answer here") + '"></textarea>')
                element.find(".choiceArea").append(choiceElement)
                element.find(".nextBtn").on("click", function() {
                    var answer = element.find("textarea").val()
                    if (answer) {
                        Quiz.makeChoice(question, answer)
                    }
                })
                break
            case "Sponsor":
                element.find(".nextBtn").on("click", function() {
                    Quiz.makeChoice(question)
                })
                break
        }
        $(".wrapper .quizCOntent").append(element)
    },

    getQuestion: function(question_id) {
        var question = null
        for (let i = 0; i < Quiz.sections.length; i++) {
            question = Quiz.sections[i].questions.find(function(q) {
                return q.question_id == question_id
            })
            if (question) break
        }
        return question
    },

    makeChoice: function(question, value, choice_id) {
        const canProceed = Quiz.canMakeChoice(value, choice_id, question)
        if (canProceed) {
            $(".incorrectAnswerAlert").css("min-height", "0")
            if (Quiz.taker_id !== undefined) {
                Quiz.saveAnswer(value, choice_id)
            } else {
                if (Quiz.preview) {
                    Quiz.taker_id = 0
                    Quiz.saveAnswer(value, choice_id)
                } else {
                    Quiz.createTaker({}).then(function(result) {
                        if (result.status == "success") {
                            Quiz.saveAnswer(value, choice_id)
                        }
                    })
                }
            }
        } else {
            const errorAlert = $(".incorrectAnswerAlert")
            errorAlert.css("min-height", "60px")
            const text = $(".incorrectAnswerAlertText")
            text.animate({ "font-size": "21px" })
            text.animate({ "font-size": "16px" })
            errorAlert.animate({ "background-color": "#daadad" })
            errorAlert.animate({ "background-color": "#f1e4e4" })
            return false
        }
    },

    canMakeChoice(value, choice_id, question) {
        if (Quiz.app_type == "quiz" && Quiz.type == "graded" && question.required == 1) {
            if (question.type.includes("select")) {
                let answer = choice_id
                if (question.type == "select_rank") {
                    answer = choice_id.join("|")
                } else if (question.type == "select_multiple") {
                    answer = choice_id.sort((a, b) => a - b).join("|")
                }
                return answer == question.correct_answer
            } else {
                if (question.type == "Sponsor") return true
                return question.correct_answer == value
            }
        }
        return true
    },
    show: function() {
        var user = JSON.stringify(this.responses, null, "\t")
        user.replace('"', "")
        $(".userModel").empty()
        $(".userModel").html(user)
    },

    saveAnswer: function(answer, choice_id) {
        var response = {
            question: this.sections[this.currSection].questions[this.currQuestion].title.trim(), //if there is whitespace at the beginning or end of title, it wraps the string in quotes when it assigns it as the \Models\User key, so we trim it to fix that
            question_id: this.sections[this.currSection].questions[this.currQuestion].question_id,
            answer: answer,
            choice_id: choice_id ? choice_id : null,
            taker_id: Quiz.taker_id,
        }

        this.responses["question_" + response.question_id] = { response: answer, question_id: response.question_id, choice_id: choice_id }
        postMessage.events.userCompleteQuestion(Quiz.taker_id, response.question_id)

        if (Quiz.preview) {
            Quiz.nextQuestion()
        } else {
            $.api.quizTaker.saveResponse(Quiz.taker_id, { response: response }).then((result) => {
                if (result.status == "success") {
                    //this.showModel();
                    Quiz.nextQuestion()
                } else {
                    //('SOMETHING DIDNT WORK');
                }
            })
        }
    },

    showError: function(message) {
        $(".error").remove()
        $(".wrapper").prepend('<div class="error"><p>' + message + "</p></div>")
        $("html, body").animate({ scrollTop: 0 }, 400)
    },

    showFinished: function() {
        this.showProgress(100)

        $(".redloader").hide()

        var loadingScreen = $(
            '<div class="quizLoadingScreen">' + '<div class="vcenter textCenter">' + "<h4>Done! Loading Results...</h4>" + '<h1><i class="fa fa-circle-o-notch fa-spin"></i></h1>' + "</div>" + "</div>"
        ).css("opacity", 0)

        var wrapper = $(".wrapper").addClass("has-loading-screen")

        wrapper.append(loadingScreen)

        loadingScreen.animate({ opacity: 1 }, 400)

        setTimeout(() => {
            postMessage.events.userCompleteSurvey(this.taker_id)
            if (this.preview) {
                this.getPreviewResults().then((data) => {
                    this.buildQuizResults(data)
                    loadingScreen.animate({ opacity: 0 }, 300, function() {
                        loadingScreen.remove()
                        wrapper.removeClass("has-loading-screen")
                    })
                    setTimeout(() => {
                        this.setIframeHeight()
                    }, 1500)
                })
            } else {
                if (!this.taker_id) {
                    alert("Cannot complete " + this.nameType + " without a valid user")
                    return
                }
                this.completeQuiz().then((result) => {
                    var fields = this.required_fields ? this.required_fields.split(",") : null
                    if (!(this.type == "poll" && fields && !this.preview)) {
                        this.sendEmail()
                    }
                    this.buildQuizResults(result.data)
                    loadingScreen.animate({ opacity: 0 }, 300, () => {
                        loadingScreen.remove()
                        wrapper.removeClass("has-loading-screen")
                    })
                    setTimeout(() => {
                        this.setIframeHeight()
                        FormUser.logout()
                    }, 1500)
                })
            }
        }, 1000)
    },
    completeQuiz: function() {
        let referrerData = {}
        if (this.referrerId) {
            referrerData = { referrer_id: Utils.crockfordDecode(this.referrerId), share_type: this.shareType }
        }

        return $.api.quizTaker.completeQuiz(Quiz.taker_id, referrerData).then((result) => {
            if (Environment.field) {
                var score = null,
                    scorePossible = null
                if (result.status == "success" && result.data.score) {
                    score = result.data.score.score
                    scorePossible = result.data.score.scorePossible

                    if (Quiz.userInfo && Quiz.userInfo.person_id) {
                        $.api.accountPerson.updateFromAppIdAndHash({
                            app_id: Quiz.app_id,
                            email_hash: Quiz.userInfo.email_hash,
                            data: Object.assign(Quiz.userInfo.data, { surveyStatus: "finished", takerId: result.data.model.taker_id }),
                        })
                    }
                }
                finishQuizCallback(score, scorePossible)
            }

            return result
        })
    },
    makeResultsChoices: function(results) {
        var html = ""
        var isNumeric = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n)
        }
        var objectIndexOf = function(arr, column, search) {
            var index = -1
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][column] == search) {
                    index = i
                    break
                }
            }
            return index
        }
        var makeResponse = function(question, response) {
            if (question.type == "Rater") {
                var str = ""
                for (var i = 1; i < parseInt(response) + 1; i++) {
                    str += '<i class="fa fa-star"></i>'
                }
                return str
            } else {
                return response
            }
        }

        var makeChoice = function(question, response, isCorrect, isPicked, hasStats, percent, choice) {
            var correctClass = Quiz.show_correct_answers ? (isCorrect ? "correct" : "incorrect") : ""

            if (question.question_format != "grid") {
                if (!response) {
                    return ""
                }
            }
            return (
                '<div class="results-choice ' +
                correctClass +
                " " +
                (isPicked ? "picked" : "") +
                " " +
                (hasStats ? "has-stats" : "") +
                " " +
                (choice && choice.image ? "has-image" : "") +
                '">' +
                (question.question_format == "grid" && choice && choice.image
                    ? '<div class="choiceImage" style="background-image: url(' + process.env.CDN + "medium_" + choice.image + ')"></div>'
                    : "") +
                (question.question_format == "grid" && !response.trim() ? "" : '<div class="content">' + makeResponse(question, response) + "</div>") +
                '<div class="score-marker ' +
                (hasStats ? "" : "hidden") +
                '" style="width: ' +
                percent +
                '%;"></div>' +
                '<div class="content-mask-wrap ' +
                (hasStats ? "" : "hidden") +
                '" style="width: ' +
                percent +
                '%;">' +
                '<div class="content-mask">' +
                (question.question_format == "grid" ? "" : makeResponse(question, response)) +
                (hasStats ? '<div class="score-shadow">' + percent + "%</div>" : "") +
                "</div>" +
                "</div>" +
                (hasStats ? '<div class="score">' + percent + "%</div>" : "") +
                "</div>"
            )
        }

        Quiz.sections.forEach(function(section) {
            html += '<div class="results-section">'
            if (Quiz.type == "survey") {
                html += '<div class="section-heading">' + "<h2>" + section.section_name + "</h2>" + "</div>"
            }
            section.questions.forEach(function(question) {
                if (!Quiz.validQuestion(question) || question.type == "Sponsor") {
                    return
                }
                var response = Quiz.responses["question_" + question.question_id] || { response: false },
                    statQuestion = results.stats ? results.stats.questions.find(({ question_id }) => question_id == question.question_id) : false,
                    statChoice = false,
                    userChoiceTotal = statQuestion ? statQuestion.total : 0

                html += '<div class="results-question ' + question.question_format + '" data-question="' + question.type + '">'
                html += "<h3>" + question.title + "</h3>"
                if (["select_one", "select_multiple"].includes(question.type)) {
                    question.choices.forEach(function(choice) {
                        statChoice = statQuestion ? statQuestion.choices.find(({ choice_id }) => choice_id == choice.choice_id) : false
                        let isPicked
                        if (["select_multiple"].includes(question.type)) {
                            isPicked = response.choice_id.indexOf(parseInt(choice.choice_id)) > -1
                        } else if (question.type == "select_one") {
                            isPicked = response.choice_id == choice.choice_id
                        }

                        var picked = statChoice ? statChoice.total : 0,
                            isCorrect = choice.correct > 0,
                            pickedPercent = Math.round((picked / userChoiceTotal) * 100) || 0,
                            responseValue = choice.display,
                            hasStats = !!results.stats

                        html += makeChoice(question, responseValue, isCorrect, isPicked, hasStats, pickedPercent, choice)
                    })
                } else if (question.type == "select_rank") {
                    question.choices
                        .sort(function(a, b) {
                            if (a.correct == b.correct) {
                                return 0
                            }

                            return parseInt(a.correct) > parseInt(b.correct) ? 1 : -1
                        })
                        .forEach(function(choice) {
                            statChoice = statQuestion ? statQuestion.choices.find(({ choice_id }) => choice_id == choice.choice_id) : false
                            userChoiceTotal = Quiz.type == "graded" ? statQuestion.responses : statQuestion.total

                            let choicePoints = statChoice.total
                            let isPicked = false
                            let isCorrect = choice.correct == response.response.indexOf(choice.value) + 1
                            let pickedPercent = Math.round((choicePoints / userChoiceTotal) * 100) || 0
                            let responseValue = "# " + (choice.correct || "") + " " + (choice.display || "")
                            let hasStats = !!results.stats

                            html += makeChoice(question, responseValue, isCorrect, isPicked, hasStats, pickedPercent, choice)
                        })
                } else {
                    var userChoices = []

                    if (results.stats) {
                        $.each(statQuestion.choices, function(_index, choice) {
                            userChoices.push({ total: choice.total, response: choice.answer })
                        })

                        userChoices = userChoices.sort(function(a, b) {
                            if (b.total - a.total != 0) {
                                return b.total - a.total
                            }
                            var ar = isNumeric(a.response) ? parseFloat(a.response) : a.response,
                                br = isNumeric(a.response) ? parseFloat(b.response) : b.response

                            if (ar < br) return -1
                            if (ar > br) return 1
                            return 0
                        })

                        var responseIndex = objectIndexOf(userChoices, "response", response.response),
                            correctIndex = objectIndexOf(userChoices, "response", question.correct_answer)

                        userChoices = userChoices.filter((_, key) => {
                            var maxIndex = responseIndex > 3 ? 2 : 3
                            if (correctIndex > maxIndex) {
                                maxIndex -= 1
                            }
                            return key <= maxIndex || key == responseIndex || key == correctIndex
                        })
                    }
                    if (userChoices.length) {
                        html += userChoices
                            .map(function(userChoice) {
                                var picked = userChoice.total,
                                    pickedPercent = Math.round((picked / statQuestion.total) * 100) || 0,
                                    responseValue = userChoice.response,
                                    isCorrect = question.correct_answer == userChoice.response,
                                    isPicked = userChoice.response == response.response,
                                    hasStats = true

                                return makeChoice(question, responseValue, isCorrect, isPicked, hasStats, pickedPercent)
                            })
                            .join("\n")
                    } else {
                        var picked = statQuestion.total,
                            pickedPercent = Math.round((picked / statQuestion.responses) * 100) || 0

                        html += makeChoice(question, question.correct_answer, true, response.response == question.correct_answer, Quiz.show_response_stats, pickedPercent)

                        if (response.response != question.correct_answer) {
                            html += makeChoice(question, response.response, false, true, false, false)
                        }
                    }
                }
                html += "</div>"
            })
            html += "</div>"
        })

        html = $(html)

        html.find(".results-question").each(function() {
            var questionElem = $(this)

            if (Quiz.type == "graded" && Quiz.show_correct_answers) {
                if (questionElem.attr("data-question") == "select_rank") {
                    if (questionElem.find(".results-choice.correct").length == questionElem.find(".results-choice").length) {
                        questionElem.children("h3").prepend('<i class="fa fa-check-circle" style="color: #4a984a;"></i>')
                    } else {
                        questionElem.children("h3").prepend('<i class="fa fa-times-circle" style="color: #ca4b4b;"></i>')
                    }
                } else {
                    if (questionElem.find(".correct").length == questionElem.find(".correct.picked").length && questionElem.find(".correct").length == questionElem.find(".picked").length) {
                        questionElem.children("h3").prepend('<i class="fa fa-check-circle" style="color: #4a984a;"></i>')
                    } else {
                        questionElem.children("h3").prepend('<i class="fa fa-times-circle" style="color: #ca4b4b;"></i>')
                    }
                }
            }
        })

        return html
    },
    showRequiredFieldsAtPollEnd(quizResults) {
        const choiceArea = $(".wrapper .choiceArea")
        this.makeRequiredFields(choiceArea.find(".choice-results"))

        $(strip/*html*/ `
            <div class="button nextBtn themeBtn">
                View Poll Results
                <span class="fa fa-arrow-right"></span>
            </div>
        `)
            .appendTo(choiceArea.find(".choice-results"))
            .on("click", () => {
                var errors = this.validateRequiredFields(choiceArea.find(".choice-results"))
                if (errors.length) {
                    return false
                }

                if (this.getOptIns()) {
                    errors = this.validateOptIns()
                    if (errors.length) {
                        return false
                    }
                }

                var info = {
                    ...this.getRequiredFieldsInfo(choiceArea.find(".choice-results")),
                }

                this.updateTaker(info).then(() => {
                    this.sendEmail()

                    choiceArea
                        .find(".choice-results")
                        .empty()
                        .append(this.makeResultsChoices(quizResults))
                    this.resize()
                    this.setIframeHeight()

                    setTimeout(() => {
                        FormUser.logout()
                    }, 1500)
                })
            })
    },
    showFormAtPollEnd(quizResults) {
        if (this.offline_contest > 0) {
            const choiceArea = $(".wrapper .choiceArea")
            this.updateTaker()
            choiceArea.find(".choice-results").append(this.makeResultsChoices(quizResults))
            this.resize()
            this.setIframeHeight()
            return
        }
        const choiceArea = $(".wrapper .choiceArea")
        choiceArea.append('<div class="formWrapper"></div>')
        this.initializeForm({
            events: {
                onCompleteEntry: ({ user: { user: user_id } }) => {
                    this.updateTaker({ user_id }).then(() => {
                        this.sendEmail()
                        choiceArea.find(".formWrapper").hide()
                        choiceArea
                            .find(".choice-results")
                            .empty()
                            .append(this.makeResultsChoices(quizResults))

                        this.resize()
                        this.setIframeHeight()

                        setTimeout(() => {
                            FormUser.logout()
                        }, 1500)
                    })
                },
            },
        })
    },
    buildQuizResults: function(results) {
        var target = $(".wrapper"),
            html = "",
            choiceArea = target.find(".choiceArea").removeAttr("data-format"),
            fields = Quiz.required_fields ? Quiz.required_fields.split(",") : null

        target
            .find(".questionTitle p")
            .html("")
            .addClass("hidden")

        if (results.outcome) {
            target.find(".questionTitle h3").fadeOut(100, function() {
                $(this)
                    .html(results.outcome.name)
                    .fadeIn()
                    .css("font-weight", "bold")
            })

            if (results.outcome.description) {
                target
                    .find(".questionTitle p")
                    .css("font-weight", "bold")
                    .hide()
                    .removeClass("hidden")
                    .html(unescape(Quiz.nl2br(results.outcome.description)))
                    .slideDown()
            }

            this.changeHeaderMedia("image", results.outcome.image, results.outcome.image_display == "cover")
        } else {
            this.changeHeaderMedia("image", Quiz.primary_image, Quiz.primary_image_display == "cover")
            if (Quiz.finish_message?.length) {
                target.find(".questionTitle > div:last").html(unescape(Quiz.nl2br(Quiz.finish_message)))
            } else {
                if (Quiz.type == "graded") {
                    target.find(".questionTitle h3").fadeOut(100, function() {
                        $(this)
                            .html("You got " + results.score.score + " out of " + results.score.possible)
                            .fadeIn()
                    })
                } else {
                    target.find(".questionTitle h3").fadeOut(100, function() {
                        $(this)
                            .html("Thank you for participating")
                            .fadeIn()
                    })
                }
            }
        }

        if (Quiz.type == "graded") {
            html += '<div class="graded-title">' + "<h1>Your Score " + results.score.percent + "%</h1>" + "</div>"
        }

        if (Quiz.show_share_options) {
            html += strip/*html*/ `
                <div class="quiz-social-links">
                    <h3>Share this ${Quiz.nameType}</h3>
                    <div class="shareButtons">
                        <div class="facebookShareButton shareButton" data-share="facebook"><i class="fa fa-facebook"></i></div>
                        <div class="twitterShareButton shareButton" data-share="twitter"><i class="fa fa-twitter"></i></div>
                        <div class="linkShareButton shareButton" data-share="link">
                            <div class="icon">
                                <i class="fa fa-link"></i>
                            </div>
                            <input type="text" id="entryLink" class="opaque" readonly="" value="${Quiz.getShareLink(Quiz.taker_id)}">
                        </div>
                    </div>
                </div>
            `
        }

        html += /*html*/ `<div class="choice-results"></div>`

        if ((Quiz.taker.submission_count || 0) + 1 < (Quiz.max_submissions || 1)) {
            html += strip/*html*/ `
                <div class="quizRepeatButton">
                    <a href="?user=${Quiz.taker_id}" class="btn whiteBtn largeBtn">
                        Retake this ${Quiz.nameType}?
                    </a>
                </div>
            `
        }
        choiceArea.addClass("padded results results-" + Quiz.type).html(html)

        if (Quiz.show_user_choices) {
            if (Quiz.type == "poll" && fields && !Quiz.preview) {
                if (this.hasForm) {
                    this.showFormAtPollEnd(results)
                } else {
                    this.showRequiredFieldsAtPollEnd(results)
                }
            } else {
                choiceArea.find(".choice-results").append(Quiz.makeResultsChoices(results))
                Quiz.resize()
                Quiz.setIframeHeight()
            }
        }

        if (Quiz.show_correct_answers) {
            choiceArea.addClass("results-answers")
        }
        choiceArea.addClass(Quiz.show_response_stats ? "results-stats" : "results-no-stats")

        target.find(".questionBottom").remove()

        target.find(".shareButton").on("click", function() {
            var clicked = $(this),
                shareType = clicked.attr("data-share"),
                input = clicked.find("input")

            $.api.app.trackShare(Quiz.app_id, {
                app_user_id: Quiz.taker ? Quiz.taker.taker_id : 0,
                type: shareType,
            })

            if (shareType == "link") {
                input.trigger("select")
                try {
                    document.execCommand("copy")
                    input.trigger("blur")
                    setTimeout(() => {
                        input.trigger("blur")
                    }, 100)
                    $.notify.success(tr("quiz.copy.entrylink.success", "Smart link copied to clipboard!"))
                } catch (err) {
                    console.warn("exect error", err)
                }
            } else if (shareType == "facebook") {
                window.FB.ui(
                    {
                        method: "feed",
                        link: Quiz.getShareLink(Quiz.taker_id) + "_f",
                    },
                    function(_response) {}
                )
            } else if (shareType == "twitter") {
                var message = ""

                if (Quiz.type == "graded") {
                    message = (Quiz.share_twitter || "Check out this quiz!") + ' "' + Quiz.title + '"'
                } else if (Quiz.type == "outcome") {
                    message = (Quiz.share_twitter || "Check out this quiz!") + ' "' + Quiz.title + '"'
                } else if (Quiz.type == "survey") {
                    message = (Quiz.share_twitter || "Check out this quiz!") + ' "' + Quiz.title + '"'
                } else if (Quiz.type == "poll") {
                    message = (Quiz.share_twitter || "Check out this poll!") + ' "' + Quiz.title + '"'
                }

                if (Quiz.taker_id) {
                    if (Quiz.type == "graded" || Quiz.type == "outcome") {
                        if (results.score) {
                            message = (Quiz.share_twitter || "Check out this quiz.") + " I got " + results.score.score + " out of " + results.score.possible
                        } else if (results.outcome) {
                            message = (Quiz.share_twitter || "Check out this quiz.") + ' I got ... "' + results.outcome.name + '"'
                        }
                    }
                }

                var twitter_popup = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(message) + "&url=" + encodeURIComponent(Quiz.getShareLink(Quiz.taker_id)) + "_t"
                window.open(twitter_popup, "twitter", "width=600, height=300, toolbar=0, scrollbars=0, left=300, top=300")
            }
        })
    },
    resize: function() {
        if (Quiz.show_response_stats) {
            $(".choiceArea")
                .find(".results-choice")
                .each(function() {
                    var choice = $(this),
                        //content = choice.children('.content').first(),
                        width = choice.width()

                    if (choice.closest(".results-question").hasClass("grid")) {
                        width += 10
                    }
                    choice.find(".content-mask").css({ width: width })
                })
        }
    },
    getPreviewResults: function() {
        var deferred = $.Deferred()

        var stats = {
            outcome: null,
            score: null,
            stats: null,
        }

        var calls = []
        var responses = this.getResponses()
        if (Quiz.type == "graded") {
            calls.push(
                Quiz.getPreviewScore(responses).then(function(data) {
                    if (data.status == "success") {
                        stats.score = data.data.score
                    }
                })
            )
            calls.push(
                Quiz.getPreviewGradedOutcome(responses).then(function(result) {
                    if (result.status == "success") {
                        stats.outcome = result.data.outcome
                    }
                })
            )
        } else if (Quiz.type == "outcome") {
            calls.push(
                Quiz.getPreviewOutcomeOutcome(responses).then(function(result) {
                    if (result.status == "success") {
                        stats.outcome = result.data.outcome
                    }
                })
            )
        }
        if (Quiz.show_response_stats) {
            calls.push(
                Quiz.getResponseStats().then((result) => {
                    if (result.status == "success") {
                        stats.stats = result.data.stats
                    }
                })
            )
        }

        $.when.apply($, calls).then(function() {
            deferred.resolve(stats)
        })
        return deferred.promise()
    },
    getResponseStats: function() {
        return $.api.quiz.getResponseStats(Quiz.app_id)
    },
    getPreviewGradedOutcome: function(responses) {
        return $.api.quizTaker.fetchGradedOutcome({
            responses: responses || this.getResponses(),
            score: false,
            app_id: Quiz.app_id,
        })
    },
    getPreviewOutcomeOutcome: function(responses) {
        return $.api.quizTaker.fetchOutcomeOutcome({
            responses: responses || this.getResponses(),
            app_id: Quiz.app_id,
        })
    },
    getPreviewScore: function(responses) {
        return $.api.quizTaker.fetchScore({
            responses: responses || this.getResponses(),
            app_id: Quiz.app_id,
        })
    },
    getResponses: function() {
        var responses = []
        $.each(this.responses, function(key, value) {
            var question_id = key.split("_")[1],
                question = $.extend({}, Quiz.getQuestion(question_id)),
                answer = value.response,
                choice_id = value.choice_id || 0

            delete question.choices
            delete question.currChoices

            responses.push(
                $.extend({}, question, {
                    question_id: question_id,
                    app_id: Quiz.app_id,
                    question: question.title,
                    answer: typeof answer == "object" ? answer.join(",") : answer,
                    choice_id: choice_id,
                    is_correct: 0,
                })
            )
        })

        return responses
    },
    showScore: function(score) {
        $(".wrapper").html("<h2>" + tr("quiz.score.heading", "You got [actual_score] / [possible_score]", { actual_score: score.score, possible_score: score.possible }) + "</h2><br/><br/>")
        $.each(score.responses, (_, response) => {
            var question = Quiz.getQuestion(response.question_id)

            let correctAnswer
            if (["select_one", "select_multiple", "select_rank"].indexOf(question.type) > -1) {
                correctAnswer = question.choices
                    .filter(function(choice) {
                        return parseInt(choice.correct)
                    })
                    .map(function(choice) {
                        return choice.value
                    })
                    .join(", ")
                if (!correctAnswer) {
                    correctAnswer = tr("quiz.score.correct_all", "All Questions Are Correct")
                }
            } else {
                correctAnswer = question.correct_answer ? question.correct_answer : tr("quiz.score.correct_all", "All Questions Are Correct")
            }

            var $element = $(
                "<div class='quizResult " +
                    (response.is_correct ? "correct_answer" : "incorrect_answer") +
                    "'>" +
                    "<h4>" +
                    question.title +
                    "</h4>" +
                    "<p class='myanswer'>" +
                    tr("quiz.score.your_answer", "YOUR ANSWER") +
                    ": " +
                    response.answer +
                    "</p>" +
                    "<p class='correctAnswer'>" +
                    tr("quiz.score.correct_answer", "CORRECT ANSWER") +
                    ": " +
                    correctAnswer +
                    "</p>" +
                    "</div>"
            )
            $(".wrapper").append($element)
        })
        $(".wrapper").append("<div class='finishBtn button'>" + tr("quiz.button.finish", "Finish") + " <span class='glyphicon glyphicon-chevron-right'></span></div>")
    },
    showReward: function(reward, name) {
        var popup = $(".rewardsPopup").popup()

        popup.find(".popupBody").html(reward)
        popup.find(".popupHeader h3").text(name)

        popup.popup("show")
    },
    showProgress: function(width) {
        if (!width) width = ((Quiz.answeredQuestions - 1) / Quiz.totalQuestions) * 100
        if (isNaN(width)) {
            $(".progressWrapper")
                .find(".percentComplete")
                .html("0%")
        } else if (Quiz.answeredQuestions > 0) {
            $(".progressWrapper")
                .find(".percentComplete")
                .html(Math.round(width) + "%")
            $(".progress-bar").animate({ width: width + "%" })
        }
    },
    sendEmail: function() {
        return $.api.quizTaker.sendEmail(Quiz.taker_id, {})
    },
    unesc: function(string) {
        string = Utils.replaceAll(string, "&quot;", '"')
        string = Utils.replaceAll(string, "&apos;", "'")
        return string
    },

    esc: function(string) {
        string = Utils.replaceAll(string, '"', "&quot;")
        string = Utils.replaceAll(string, "'", "&apos;")
        return string
    },
    nl2br: function(text) {
        return Utils.replaceAll(text, "\n", "<br>")
    },
    getShareLink: function(entry_id) {
        return process.env.ULINK_HOST + Utils.crockfordEncode(Quiz.app_id) + (entry_id ? "-" + Utils.crockfordEncode(entry_id) : "")
    },
    setIframeHeight: function() {
        postMessage.setIframeHeight($("body").height())
    },
}

Quiz.initialize()

export default Quiz
